import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovGroupProps,
    LoadMarkovGroupById,
    setMarkovGroupEdit,
    setMarkovGroupReloadEdit,
    initMarkovGroup,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    groupId = null,
}: MarkovGroupProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const group = useSelector((state: StoreType) => state.markovGroup.groupEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovGroup.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovGroupReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovGroupReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (groupId === 0) {
            dispatch(setMarkovGroupEdit(initMarkovGroup))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovGroupById(groupId, model.id).then((res) => {
                dispatch(setMarkovGroupEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!group) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{group.id ? `${lang.editGroup} # ${group.id}` : lang.addGroup}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form group={group} />
                }
                {
                    reloadEdit
                    && <Form group={group} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
